import axios from "axios";
import { errorResponse } from "src/store/common";
import { alertMessages, mutateStationMeta } from "src/constants";
import { configMutationClimatology } from "./mutationsApiKey";

export const createUpdateStationMeta = async (params: any, addAlert: any) => {
    try {
        let data = JSON.stringify({
            query: mutateStationMeta,
            variables: {
                stationId: params.stationId,
                vpd_min_percentile: params.vpd_min_percentile,
                vpd_max_percentile: params.vpd_max_percentile,
                avg_annual_precip: Number(params.avg_annual_precip),
                weather_daily_visible: params.weather_daily_visible,
                nfdrs_daily_visible: params.nfdrs_daily_visible,
                weather_hourly_visible: params.weather_hourly_visible,
                nfdrs_hourly_visible: params.nfdrs_hourly_visible,
                weather_daily_download: params.weather_daily_download,
                weather_hourly_download: params.weather_hourly_download,
                nfdrs_hourly_download: params.nfdrs_hourly_download,
                nfdrs_daily_download: params.nfdrs_daily_download,
                produce_nfdrs: params.produce_nfdrs,
                ingest_observation: params.ingest_observation,
                station_metadata_visible: params.station_metadata_visible

            }
        });
        let config = configMutationClimatology(data, null);
        return (
            new Promise(function (resolve, reject) {
                axios(config)
                    .then(async function (response: any) {
                        if (response?.data.errors) {
                            return reject(new Error(response.data.errors[0].message))
                        }
                        else {
                            return resolve(response)

                        }
                    })
                    .catch(function (error: any) {
                        console.log('error', error);
                        return reject(new Error(error))
                    });
            })
        )
    }
    catch (error) {
        console.log('error', error);
        errorResponse(error, addAlert, alertMessages.apiKey);

    }
};